import { useCallback, useMemo, useState } from "react";
import { CustomerEditDrawer } from "../customer-drawer/CustomerEditDrawer";
import { CustomerProfileLauncherContext } from "./CustomerProfileLauncherContext";

export function CustomerProfileOverlayProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [zIndex, setZIndex] = useState(undefined);

  const openCustomerProfile = useCallback((nextCustomer, options) => {
    if (nextCustomer) { setZIndex(options?.zIndex); setCustomer(nextCustomer); }
  }, []);

  const closeCustomerProfile = useCallback(() => setCustomer(null), []);
  const value = useMemo(() => ({ openCustomerProfile, closeCustomerProfile }), [openCustomerProfile, closeCustomerProfile]);

  return (
    <CustomerProfileLauncherContext.Provider value={value}>
      {children}
      <CustomerEditDrawer
        customer={customer}
        open={!!customer}
        defaultTab="customer"
        placement="right"
        zIndex={zIndex}
        onClose={closeCustomerProfile}
        onSaved={updated => setCustomer(updated)}
        onFieldChanged={patch => setCustomer(current => current ? { ...current, ...patch } : current)}
      />
    </CustomerProfileLauncherContext.Provider>
  );
}
